import { render, staticRenderFns } from "./InstancesSlimList.vue?vue&type=template&id=3c8447a3&"
import script from "./InstancesSlimList.vue?vue&type=script&lang=js&"
export * from "./InstancesSlimList.vue?vue&type=script&lang=js&"
import style0 from "./InstancesSlimList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports